module.exports = __webpack_public_path__ + "img/3.77cacc32.jpg";